import gsap from 'gsap'
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);
import { part2Play,part2Leave } from '../fx/Common'


export default class revealPart2
{
  constructor(view)
  {
    this.DOM = {
      title: view.querySelector('.title')
    }
    this.FX = {
      title:new SplitText(this.DOM.title, { type:"chars" })
    }
    gsap.set(this.FX.title.chars, { autoAlpha: 0 })
    this.tl = gsap.timeline()
  }

  destroy()
  {
    gsap.set(this.FX.title.chars, { autoAlpha:0 })
  }

  play()
  {
    part2Play(this.tl,this.FX.title.chars)
  }

  leave(cbStart=null,cbComplete=null)
  {
    part2Leave(this.tl,this.FX.title.chars,cbStart,cbComplete)

  }
}
